module.exports = __webpack_public_path__ + "static/img/service_passprime_icon_1.d2f08d38.svg";